import React from 'react';
import {
  Box,
  Image,
  StackLayout,
  UtilityText,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';

type AvatarProps = {
  image?: string;
  imageAltText: string;
  initials?: string;
  icon?: string;
  iconAltText?: string;
};

export function Avatar({
  image,
  imageAltText,
  initials,
  icon,
  iconAltText,
}: AvatarProps) {
  if (!image && !initials) {
    return null;
  }

  return (
    <Box
      style={{ position: 'relative' }}
      css={{ width: '$three', height: '$three' }}
      data-testid="avatar"
    >
      {icon ? (
        <Image
          src={icon}
          alt={iconAltText}
          width={20}
          height={20}
          css={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            borderRadius: '$circle',
            borderWidth: '$thin',
            borderStyle: 'solid',
            backgroundColor: '$surfaceBackgroundPrimary',
            borderColor: '$surfaceBackgroundPrimary',
          }}
        />
      ) : null}
      {image ? (
        <Image width={48} height={48} src={image} alt={imageAltText} />
      ) : (
        <StackLayout
          horizontalAlignment="center"
          verticalAlignment="center"
          css={{
            width: '100%',
            height: '100%',
            borderRadius: '$circle',
            backgroundColor: '$surfaceBackgroundSecondary',
          }}
        >
          <UtilityText
            css={{
              textTransform: 'uppercase',
            }}
          >
            {initials}
          </UtilityText>
          <VisuallyHidden>{imageAltText}</VisuallyHidden>
        </StackLayout>
      )}
    </Box>
  );
}
